import React from "react";

export const EmailDisclosure = () => {
    return <div id="emailModal" className="modal fade" role="dialog">
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                    <button type="button" className="close" data-bs-dismiss="modal">&times;</button>
                    <h4 className="modal-title">Email Communications</h4>
                </div>
                <div className="modal-body">
                    <div className="text-left">
                        <p>By default, members will receive the following communications via email. At any time, once logged in, you can choose which emails your wish to receive (or not) via the <strong>My Details</strong> section:</p><br />
                        <h4>Research & Wealth Insights</h4>
                        <p>Mid-week update - Lists all the research and recommendations from the week.</p>
                        <p>Weekend Briefing - An overview of the week gone and what to expect in the week to come.</p><br />
                        <h4>Portfolio Updates</h4>
                        <p>If you add your investments to the portfolio manager you will also receive regular updates including; recommendations, alerts, market pricing, dividends, profit & loss and your overall net wealth.</p><br />
                        <h4>Exclusive Opportunities</h4>
                        <p>Featured reports, invites to investor seminars and events, plus exclusive offers.</p><br />
                        <h4>Operational communications</h4>
                        <p>As an @Constants.Investsmart group member, you will occasionally receive operational updates. These could be about new features, changes to your membership, security information, or general business updates.</p><br />
                    </div>
                </div>
            </div>
        </div>
    </div>
}


